import { render, staticRenderFns } from "./WorldView.vue?vue&type=template&id=c022f4a8&scoped=true"
import script from "./WorldView.vue?vue&type=script&lang=js"
export * from "./WorldView.vue?vue&type=script&lang=js"
import style0 from "./WorldView.vue?vue&type=style&index=0&id=c022f4a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c022f4a8",
  null
  
)

export default component.exports